import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import DatePicker from 'react-date-picker';



import './AttendanceLeave.scss';
import MyContext from '../MyContext.jsx';

var customer_XHR={'abort' : ()=>{}};



class AttendanceLeave extends Component {

    constructor(props) {
      super(props);
      this.remarksReq = React.createRef();

      this.state = {
        type : 'PRESENT',
        date : new Date(),
        from_date : '',
        to_date :'',
        no_of_days : '',
        reason:'',
        from_checked : false,
        to_checked : false,
        sid :'',
        address : null,
        status : 'IN',
        remarks:null,
        leavelist:[{
          id:'',
          from_date:'',
          to_date:'',
          no_of_days:'',
          reason:'',
          status:'',
        }]

      }
      this.formChange = this.formChange.bind(this);
    }

    attendanceCheck(){
      var obj_this = this;
      const url2=`${process.env.REACT_APP_SSS}/api/getEmployeeAttendance`;
      var newdate=new Date();
      var year=newdate.getFullYear();
      var month=newdate.getMonth()+1;
      var day=newdate.getDate();
      var currdate=`${year}-${month}-${day}`
      $.ajax({
        url:url2,
        data:{
          sid:obj_this.context.user_details.sid,
          date:currdate,
        },
        type:"GET"
      }).done(function(return_data2){
        console.log(return_data2)
        if(return_data2.status=="Unmarked"){
          // obj_this.context.setAttendance(false);
          alert("Please mark your attendance")
          obj_this.setState({
            status : return_data2.status
          });
          obj_this.props.history.replace("/employee/attendance/leave");
        }else if(return_data2.status=="Present"){
          // obj_this.context.setAttendance(true);
          if(return_data2.attendance.status){
            obj_this.setState({
              status : return_data2.attendance.status
            });
          }
          obj_this.props.history.replace("/employee/attendance/leave");
        }
      }).fail(function(){
        alert("Network Error");
        obj_this.props.history.replace('/');
      });
    }

    componentDidMount(){  
      // if(!this.context.attendance)
      this.attendanceCheck();


      if(typeof geo !== 'undefined'){
        geo.getLocation(function(location){
          if(location && location.latitude) {
              obj_this.context.setLocation(location);
              const  url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+location.latitude+','+location.longitude+'&key='+process.env.REACT_APP_GOOGLE_MAP_API_KEY;
                $.ajax({
                  url : url,
                  type : "GET"
                }).done(function(return_data){
                  // console.log(return_data);
                  if(return_data.status == "OK" && return_data.results[0]){
                    obj_this.setState({
                      address : return_data.results[0].formatted_address
                    });
                    obj_this.context.loading(0);
                  }else{
                    obj_this.context.loading(0);
                    alert("Couldn't fetch your address");
                  }
                });
          }
        });
      }
      $(".location_button").on("click",function(){
        if(typeof geo !== 'undefined'){
            var location_coordinates = obj_this.context.location;
            geo.getLocation(function(location){
            if(!location || !location.latitude) {
                obj_this.context.loading(0);
                return;
            }
            location_coordinates = location;
            obj_this.context.loading(0);
            const  url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+location_coordinates.latitude+','+location_coordinates.longitude+'&key='+process.env.REACT_APP_GOOGLE_MAP_API_KEY;
            $.ajax({
              url : url,
              type : "GET"
            }).done(function(return_data){
              // console.log(return_data);
              if(return_data.status == "OK" && return_data.results[0]){
                obj_this.setState({
                  address : return_data.results[0].formatted_address
                });
                obj_this.context.loading(0);
              }else{
                obj_this.context.loading(0);
                alert("Couldn't fetch your address");
              }
            });
           }
          )}
      });
          

      const data = new FormData();
      data.append('sid',this.context.user_details.sid);
      const url2 = `${process.env.REACT_APP_SSS}/api/getEmployeeLeaveRequestDetails`;
      var obj_this=this;
      var result2='';
      axios.post(url2,data)
      .then(res2 =>{
        // console.log(res.data);
        if(res2.data.status == "Leave Request Fetched"){
          result2=res2.data.leave;
          // console.log(result2);
          for(var i=0;i<result2.length;i++){
            var id = result2[i]['id'];
            var from_date = result2[i]['from_date'];
            var to_date = result2[i]['to_date'];
            var no_of_days=result2[i]['no_of_days'];
            // var leave_type=result2[i]['leave_type'];
            var reason=result2[i]['reason']
            var status = result2[i]['status'];
            obj_this.state.leavelist.push({ id, from_date,to_date,no_of_days,reason,status})
          }
          obj_this.state.leavelist.splice(0, 1);
          obj_this.context.loading(0);
          // console.log(obj_this.state.leavelist);

        }
        else{
          alert('Fetch failed');
        }
      });
      
    }

    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });

      // console.log(this.state);
    }

    typeChange(e){
      this.setState({
        type : e.target.value
      });
    } 
    
    onDateChange(value){
      if(value!=null){
      this.setState({date : value});
      // console.log(value);
      }
    }

    onFromChange(value){
      this.state.no_of_days=0
      if(value!=null){
      
      this.setState({from_date : value});
      var date1 = new Date(value);
      var date2 = new Date(this.state.to_date);

      var days = Math.abs(date2 - date1)
      var day = days / (1000 * 60 * 60 * 24);
      // var d = new Date(date2 - date1).getDate();
      this.getHalfDay(day);
      }
    }

    getHalfDay(d) {
      var h1 = document.querySelector('.from').checked;
      var h2 = document.querySelector('.to').checked;
      if(h1) {
        d = .5;
      }
      if(h2) {
        d = .5;
      }
      if(isNaN(d)) {
        d = "";
      }
      this.setState({
        no_of_days: d
      });
    }
    

    onToChange(value){
      this.state.no_of_days=0
      if(value!=null){
      this.setState({to_date : value});
      var date1 = new Date(this.state.from_date);
      var date2 = new Date(value);
      var days = Math.abs(date2 - date1)
      var day = days / (1000 * 60 * 60 * 24);
      // var d = new Date(date2 - date1).getDate();
      this.getHalfDay(day);
      }
    }

     fromHalfDay(e) {
      const checked = e.target.checked;
      if (checked) {
        if(this.state.no_of_days==0){
          this.setState({
            no_of_days: (.5),
            to_date:new Date()

          });
        }
      } else {
        if(this.state.no_of_days==0){
        this.setState({
          no_of_days: (.5),
          to_date:new Date()
        });      
        }
      }
    };
    toHalfDay(e) {
      const checked = e.target.checked;
      if (checked) {
        if(this.state.no_of_days==0){
        this.setState({
          no_of_days: (.5)
        });
        }
      } else {
        if(this.state.no_of_days==0){
        this.setState({
          no_of_days: (.5)
        });
        }
      }
    };

    formSubmit(e){

      e.preventDefault();
      var obj_this = this;
      if(obj_this.state.type=='PRESENT'){
        if(!obj_this.context.location){
          alert("Please enable GPS Permission");
          return;
        }
        if(!obj_this.state.address){
          alert("Please wait until we fetch your location");
          return;
        }
        if(obj_this.state.status == "Unmarked"){
          if(!obj_this.state.remarks){
            obj_this.remarksReq.current.focus();
           return;
         }
        }
        if(obj_this.state.status=="OUT"){
          if(!confirm("Are you sure you want to Checkout again?")){
            return;
          }

        }
        
      }
    

      obj_this.context.loading(0);
      this.context.loading(1);

      var sid =  obj_this.context.user_details.sid;
      var fd = new FormData(document.querySelector('form'));

      fd.append('sid',sid);

      fd.append('latitude',this.context.location.latitude);

      fd.append('longitude',this.context.location.longitude);


      fd.append('address',this.state.address);


      const url = `${process.env.REACT_APP_SSS}/api/save/employee/attendance/leave/details`;

      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "Attendance"){
          alert("Attendance added.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "CheckIn"){
          alert("Checked In.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "Checkout"){
          alert("Checked Out.");
          obj_this.context.loading(0);
          // obj_this.context.setAttendance(true);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "Leave"){
          alert("Leave request added successfully.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Please Try Again");
          obj_this.props.history.replace('/');
          obj_this.context.loading(0);
        }
      });
    }    

  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_attendance_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> ADD ATTENDANCE AND LEAVE</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">

              <div className="input_label_head">{this.state.type == "PRESENT"?"Attendance Details":"Leave Details"}</div>
              <div className="input_radio_container">
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="type" 
                          value="PRESENT"  
                          checked={this.state.type == 'PRESENT'} 
                          onChange={e => this.typeChange(e)}
                        />
                        <div>PRESENT</div>
                      </div>
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="type" 
                          value="LEAVE"
                          checked={this.state.type == 'LEAVE'} 
                          onChange={e => this.typeChange(e)}
                        />
                        <div>LEAVE</div>
                      </div>
                    </div>
                </div>
                <div style={{display:this.state.type == "LEAVE"?"none":"block"}}>
   
                  <div className="input_label">Date *</div>
                <DatePicker
                  className="input custom_input transaction_date"
                  name="date"
                  onChange={(value) => this.onDateChange(value)}
                  value={this.state.date}
                  format="dd-MM-y"
                  minDate={new Date()}
                  maxDate = {new Date()}
                  required={this.state.type=="PRESENT"}
                  clearIcon={null}
                /> 
                 <div className="input_label">Location Coordinates</div>
                <div className="location_container">
                  <input className=" location complaint input custom_input"
                    type="text"
                    name="location"
                    value={this.context.location.latitude?this.context.location.latitude+", "+this.context.location.longitude:"Enable GPS Permission"}
                    onChange={this.formChange}
                    autoComplete="off"
                    disabled
                    required
                  />
                  <div className="location_button">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                </div>
                <div>
                  <div className="input_label">Current Address</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.address}
                      onChange = {this.formChange}
                      disabled
                      required
                    />
                  </div>
                </div>
                <div>
                  <div className="input_label">Current Status</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.status}
                      onChange = {this.formChange}
                      disabled
                      required
                    />
                  </div>
                </div>
                <div style={{display:this.state.status=="Unmarked"?"block":"none"}}>
                  <div className="input_label">Remarks</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "remarks"
                      value = {this.state.remarks}
                      onChange = {this.formChange}
                      ref={this.remarksReq}
                      // required = {this.state.status=="Unmarked"}
                    />
                  </div>
                </div>


                </div>
                <div style={{display:this.state.type == "LEAVE"?"block":"none"}}>
                  <span>
                <div className="input_label">From Date *</div>
                <DatePicker
                  className="input custom_input_date transaction_date"
                  name="from_date"
                  onChange={(value) => this.onFromChange(value)}
                  value={this.state.from_date}
                  minDate={new Date(new Date().toDateString())}
                  format="dd-MM-y"
                  required={this.state.type=="LEAVE"}
                  clearIcon={null}
                /> 
                 <input type="checkbox" 
                      className="from"
                      name="" 
                      value="" 
                      onClick={e => this.fromHalfDay(e)}

                                       /> 
                  <span className="input_label">Half Day </span>

                </span>
                <div className="input_label">To Date *</div>
                <DatePicker
                  className="input custom_input_date transaction_date"
                  name="to_date"
                  disabled={!this.state.from_date}
                  onChange={(value) => this.onToChange(value)}
                  value={this.state.to_date}
                  minDate={this.state.from_date}
                  format="dd-MM-y"
                  required={this.state.type=="LEAVE" && this.state.from_date}
                  clearIcon={null}
                /> 
                <input type="checkbox" 
                      className="to"
                      name="" 
                      value="" 
                      onClick={e => this.toHalfDay(e)}
                    /> 
                  <span className="input_label">Half Day </span>
                  <div className="input_label">Total Days *</div>
                  <input className="name input custom_input"
                    type="number"
                    name="no_of_days"
                    value={this.state.no_of_days}
                    onChange={this.formChange}
                    required={this.state.type=="LEAVE"}
                    autoComplete="off"
                  />
                 <div className="input_label">Reason *</div>
                  <textarea className="input billing_address custom_input" 
                    name="reason"
                    value={this.state.reason}
                    onChange={this.formChange}
                    required={this.state.type=="LEAVE"}
                    autoComplete="off"
                  /> 
                </div>
            </div>

              <button type="submit" className="submit_button"><i className="far fa-save"></i> {this.state.type =="PRESENT"?this.state.status=="Unmarked"?"Punch In":this.state.status=="IN"?"Punch Out":"Punched out Successfully":"Save"}</button>
            </form>   

            <div className="list_blocks_container" style={{display:this.state.type=="LEAVE"?"block":"none"}}>
              <div className="lists_container">
                {this.state.leavelist.map((item,idx)=>(
                  <div className="single_collection_container" key={idx}>
                    <div className="collection_customer_name_delete_button_container">
                    <div className="leave2_details_status_button">
                        <div className="collection_customer_name"># Days : {item.no_of_days}</div>
                        <div className="leave_status_requested" style={{display:item.status=="REQ"?"block":"none"}}><i className="fa fa-clock" aria-hidden="true"></i> REQUESTED</div>
                        <div className="leave_status_approved" style={{display:item.status=="APR"?"block":"none"}}> <i className="fa fa-check" aria-hidden="true"></i>APPROVED</div>
                        <div className="leave_status_rejected" style={{display:item.status=="CNL"?"block":"none"}}> <i className="fa fa-times" aria-hidden="true"></i>REJECTED</div>
                      </div>
                      <div className="leave_details_status_button_container">
                        <div className="leave_date"><i className="fa fa-calendar-alt"></i> {new Date(item.from_date).toLocaleDateString('en-GB')}</div>
                        <div className="divider">---</div>
                        <div className="leave_date"><i className="fa fa-calendar-alt"></i> {new Date(item.to_date).toLocaleDateString('en-GB')}</div>
                      </div>
                      {/* <div className="leave_type">Leave Type : {item.leave_type}</div> */}
                      <div className="leave2_reason">Reason : {item.reason}</div>
                    </div>
                  </div>

                ))}
              </div>
            </div>             
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default AttendanceLeave;
AttendanceLeave.contextType = MyContext;
